export var RefinancingReasons;
(function (RefinancingReasons) {
    RefinancingReasons["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReasons["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReasons["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReasons["Construction"] = "CONSTRUCTION";
    // Few more from Needs & Objectives
    RefinancingReasons["CloseToTheEndOfAFixedRateOrInterestOnlyPeriod"] = "CLOSE_TO_THE_END_OF_A_FIXED_RATE_OR_INTEREST_ONLY_PERIOD";
    RefinancingReasons["ConsolidateDebtAndReduceNumberOfLenders"] = "CONSOLIDATE_DEBT_AND_REDUCE_NUMBER_OF_LENDERS";
    RefinancingReasons["DissatisfiedWithCurrentLender"] = "DISSATISFIED_WITH_CURRENT_LENDER";
    RefinancingReasons["GreaterFlexibilityOrAdditionalLoanFeatures"] = "GREATER_FLEXIBILITY_OR_ADDITIONAL_LOAN_FEATURES";
    RefinancingReasons["IncreaseLoanAmount"] = "INCREASE_LOAN_AMOUNT";
    RefinancingReasons["PayOffLoanFasterWithALowerInterestRate"] = "PAY_OFF_LOAN_FASTER_WITH_A_LOWER_INTEREST_RATE";
    RefinancingReasons["Other"] = "OTHER";
})(RefinancingReasons || (RefinancingReasons = {}));
//# sourceMappingURL=RefinancingReasons.js.map